import { Component, Input } from '@angular/core';
import { Dictionary } from 'lodash';
import { CustomField, CustomFieldOption } from 'src/app/core/models/custom-fields.models';
import { IdeaCustomFieldValue } from 'src/app/core/models/idea.models';

@Component({
  selector: 'craft-idea-custom-item',
  templateUrl: './idea-custom-item.component.html',
  styleUrls: ['./idea-custom-item.component.scss'],
  standalone: false,
})
export class IdeaCustomItemComponent {
  @Input() public field?: CustomField;
  @Input() public showDescription = true;
  @Input() public value: IdeaCustomFieldValue;
  @Input() public optionsMap: Dictionary<CustomFieldOption>;
}
